window.BulkHireForm = function (scope, hiringRestrictionsService, backgroundChecksService, wotcDataService, $state) {
	var self = this;

	var formName = "bulk-hire-form";

	var _protected = BaseForm.call(self, formName, scope);
    var _emitter = JarEventEmitter.call(self);

	var HiringRestrictionsCheckType = hiringRestrictionsService.getHiringRestrictionsCheckType();
	var HiringRestrictionsStatus = hiringRestrictionsService.getHiringRestrictionsStatus();

    var employee_first_day;

	self.isLoading = function () {
		return self.loadingData;
	};


    self.load = function (brand_id, prospect_id, employee, start_date, isTeamScheduledEnabled, hiringRestrictionStatus) {
        self.data = {};
        self.brand_id = brand_id;
        self.prospect_id = prospect_id;
        self.employee = employee;
        self.isTeamScheduledEnabled = isTeamScheduledEnabled;
        self.hiringRestricted = {};
        self.data.allow_wotc_fields = false;
        self.data.allow_tcc_fields = false;
        self.data.showSynergyfields = false;
        self.loadingData = true;
        self.hiringRestricted.restricted = false;
        self.positions = employee.positions.filter(function (position) {
            return position.is_ready_to_hire === true;
        });
        if (self.positions.length) {
            self.data.position = self.positions[0];
            self.prospect_id = self.data.position.prospect_id;
        }
        var defer = $q.defer();

        self.candidateName = self.employee.first_name + " " + self.employee.last_name;

        var innerPromise = {};
        if(!hiringRestrictionStatus) {
            innerPromise['checkRestrictions'] = hiringRestrictionsService.checkRestrictions(self.brand_id, HiringRestrictionsCheckType.HIRING, self.prospect_id, false, self.candidateName, null, self.employee.user_id)
        }

        if (self.isTeamScheduledEnabled) {
            innerPromise['coreHREmployeeAwareness'] = TeamAPI.getCoreHREmployeeAwareness(self.brand_id, self.employee.user_id);
        }
        innerPromise['isWotcServiceEnabled'] = wotcDataService.checkWotcService(self.brand_id);

        $q.all(innerPromise)
            .then(function (result) {
                self.coreHREmployeeDetails = {};
                self.lastTerminationDate = "1970-01-01";
                self.isWotcServiceEnabled = result['isWotcServiceEnabled'];
                if (self.isTeamScheduledEnabled) {
                    self.coreHREmployeeDetails = result['coreHREmployeeAwareness'].user;
                    self.isUserOnExistingFinancialUnit = Object.keys(self.coreHREmployeeDetails).length;
                    var latestEmploymentPeriod = self.coreHREmployeeDetails && self.coreHREmployeeDetails.employment_periods && self.coreHREmployeeDetails.employment_periods[self.coreHREmployeeDetails.employment_periods.length - 1];
                    self.hireDate = latestEmploymentPeriod && latestEmploymentPeriod.hire_date;
                    self.lastTerminationDate = (self.coreHREmployeeDetails.employment_periods && self.coreHREmployeeDetails.employment_periods[0].leave_date) || "1970-01-01";
                }

                if ((hiringRestrictionStatus && [HiringRestrictionsStatus.PROCEED, HiringRestrictionsStatus.NO_RESTRICTIONS].indexOf(hiringRestrictionStatus) > -1) || [HiringRestrictionsStatus.PROCEED, HiringRestrictionsStatus.NO_RESTRICTIONS].indexOf(result['checkRestrictions'] && result['checkRestrictions'].status) > -1) {
                    var continueWithoutRestrictions = function () {
                        if (start_date) {
                            self.data.hiringDate = moment(start_date).format("MMM DD, YYYY");
                            defer.resolve();
                        } else {
                            employee_first_day = null;
                            self.isShowWarningMsg = false;

                            OnBoardingAPI.listDocuments(null, self.prospect_id, 'ON_BOARDING', null, true, null, OnBoardingAPI.DOCUMENT_TYPE.I9)
                                .then(function (docList) {

                                    docList = docList || [];
                                    docList[0] = docList[0] || {};
                                    docList[0].Document = docList[0].Document || {};
                                    docList[0].Document.meta_data = docList[0].Document.meta_data || {};

                                    if (docList[0].Document.meta_data.employee_first_day) {
                                        var i9_hiring_date = moment(docList[0].Document.meta_data.employee_first_day).format("MMM DD, YYYY");
                                        self.data.hiringDate = employee_first_day = i9_hiring_date;
                                    }
                                }, function (err) {
                                    throw err;
                                })
                                .finally(function () {
                                    defer.resolve();
                                });
                        }
                    };

                    var params = {
                        brandId: self.brand_id,
                        userIds: [self.employee.user_id],
                        prospectId: self.prospect_id,
                        positionCode: ((self.employee.position && self.employee.position.code) ? self.employee.position.code : undefined),
                    };

                    backgroundChecksService.superCheck(params)
                        .then(function () {
                            self.backgroundCheckAbort = false;
                            continueWithoutRestrictions();
                        })
                        .catch(function (err) {
                            if (!err) {
                                self.backgroundCheckAbort = true;
                                _emitter.trigger('BACKGROUND_CHECK_ABORT');
                            } else {
                                hAlert({
                                    title: $filter("translate")("Error!"),
                                    text: $filter("translate")("Oops..! something went wrong.")
                                });
                                console.error(err);
                            }
                            defer.reject();
                        });
                }
                if (["ABORT"].indexOf(result.status) > -1) {
                    self.hiringRestricted.restricted = true;
                    self.hiringRestricted.checkType = result.checkType;
                    self.hiringRestricted.cardsLength = result.cardsLength;
                    self.hiringRestricted.candidateName = result.candidateName;
                    self.hiringRestricted.documentsList = result.documentsList;
                    self.hiringRestricted.HiringRestrictionsCheckType = HiringRestrictionsCheckType;
                    self.hiringRestricted.withModal = false;
                    defer.resolve();
                }
            })
            .catch(function (err) {
                hAlert({
                    title: $filter("translate")("Error!"),
                    text: $filter("translate")("Oops..! something went wrong.")
                });
                console.error(err);
                defer.reject(err);
            })
            .finally(function () {
                if (self.isWotcServiceEnabled && !self.backgroundCheckAbort && !self.hiringRestricted.restricted) {
                    wotcDataService.getBrandWotcSettings(self.brand_id)
                        .then(function (settings) {
                            if (settings['provider'] && (settings['provider'] === "ADP")) {
                                self.data.allow_wotc_fields = true;
                                OnBoardingAPI.getJobLocations(self.brand_id, self.prospect_id)
                                    .then(async (response) => {
                                        self.jobLocations = response?.job?.locations || [];
                                        if (self.jobLocations.length === 0) {
                                            const locations = await BrandAPI.getBrandPublicLocations(self.brand_id);
                                            const brand_locations = locations || [];
                                            self.jobLocations = brand_locations.map(location => location.Location);
                                        }
                                        OnBoardingAPI.getApplicationDocumentLastMeta(self.brand_id, 'OFFER', self.prospect_id, null)
                                            .then(function (offerData) {
                                                var offerMetaData = offerData.meta_data;
                                                self.data.actual_start_date = offerMetaData?.start_date && moment(offerMetaData.start_date).format("MMM DD, YYYY");
                                                self.data.offer_sent_date = offerMetaData && offerData.state_changed_on && new Date(offerData.state_changed_on);
                                                self.data.wage = offerMetaData && offerMetaData.salary && parseFloat(offerMetaData.salary);

                                                self.loadingData = false;
                                                self.syncScope();
                                                defer.resolve();
                                            })
                                            .catch(function (err) {
                                                hAlert({
                                                    title: $filter("translate")("Error!"),
                                                    text: $filter("translate")("Oops..! something went wrong.")
                                                });
                                                console.error(err);
                                                defer.reject(err);
                                            });
                                    })
                                    .catch(function (err) {
                                        hAlert({
                                            title: $filter("translate")("Error!"),
                                            text: $filter("translate")("Oops..! something went wrong.")
                                        });
                                        console.error(err);
                                        defer.reject(err);
                                    });
                            } else if (settings['provider'] && (settings['provider'] === "TCC")) {
                                self.data.allow_tcc_fields = true;
                                var promises = {};
                                promises['offerData'] = OnBoardingAPI.getApplicationDocumentLastMeta(self.brand_id, 'OFFER', self.prospect_id, null);
                                promises['i9Data'] = OnBoardingAPI.getApplicationDocumentLastMeta(self.brand_id, 'I9',self.prospect_id, null);
                                promises['w4Data'] = OnBoardingAPI.getApplicationDocumentLastMeta(self.brand_id, 'W4', self.prospect_id, null);

                                $q.all(promises)
                                    .then(function (res) {
                                        var offerMetaData = res['offerData'].meta_data || {};
                                        var i9MetaData = res['i9Data'].meta_data || {};
                                        var w4MetaData = res['w4Data'].meta_data || {};

                                        var personalInfo = i9MetaData.personal_information || w4MetaData.personal_information;
                                        if (personalInfo) {
                                            self.data.birth_date = moment(personalInfo.birthdate);
                                            self.data.ssn = personalInfo.ssn;
                                        }
                                        self.data.actual_start_date = offerMetaData && offerMetaData.start_date && moment(offerMetaData.start_date).format("MMM DD, YYYY");
                                        self.data.offer_sent_date = res['offerData'].state_changed_on && moment(res['offerData'].state_changed_on);
                                        self.data.wage = offerMetaData && offerMetaData.salary && parseFloat(offerMetaData.salary);
                                        if (offerMetaData && offerMetaData.position_name){
                                            self.data.position_title = offerMetaData.position_name && offerMetaData.position_name;
                                        } else {
                                            var positionName;
                                            if (self.job) {
                                                if (self.job.alias_position) {
                                                    positionName = self.job.alias_position;
                                                } else if (self.job.Position) {
                                                    positionName = self.job.Position.name;
                                                }
                                            } else if (self.position) {
                                                positionName = self.position.alias || self.position.name;
                                            }

                                            self.data.position_title = positionName || "";
                                        }

                                        self.loadingData = false;
                                        self.syncScope();
                                        defer.resolve();
                                    })
                                    .catch(function (err) {
                                        hAlert({
                                            title: $filter("translate")("Error!"),
                                            text: $filter("translate")("Oops..! something went wrong.")
                                        });
                                        console.error(err);
                                        defer.reject(err);
                                    });
                            } else if (settings?.provider === wotcDataService.PROVIDER_TYPES.SYNERGI) {
                                self.data.showSynergyfields = true;
                                OnBoardingAPI.getApplicationDocumentLastMeta(self.brand_id, 'OFFER', self.prospect_id, null)
                                    .then((lastDoc) => {
                                        const offerMetaData = lastDoc.meta_data || {};
                                        self.data.wage = offerMetaData.salary && parseFloat(offerMetaData.salary);
                                        let positionName;
                                        if (self.job) {
                                            if (self.job.alias_position) {
                                                positionName = self.job.alias_position;
                                            } else if (self.job.Position) {
                                                positionName = self.job.Position.name;
                                            }
                                        } else if (self.positions[0]) {
                                            positionName = self.positions[0]?.alias || self.positions[0]?.name;
                                        }
                                        self.data.position_title = positionName || "";
                                        self.loadingData = false;
                                        self.syncScope();
                                        defer.resolve();
                                    })
                                    .catch((err) => {
                                        hAlert({
                                            title: $filter("translate")("Error!"),
                                            text: $filter("translate")("Oops..! something went wrong.")
                                        });
                                        console.error(err);
                                        defer.reject(err);
                                    });
                            }
                            else {
                                self.data.allow_wotc_fields = false;
                                self.data.allow_tcc_fields = false;
                                self.data.showSynergyfields = false;
                                self.loadingData = false;
                                defer.resolve();
                            }
                        })
                        .catch(function (err) {
                            hAlert({
                                title: $filter("translate")("Error!"),
                                text: $filter("translate")("Oops..! something went wrong.")
                            });
                            console.error(err);
                            defer.reject(err);
                        });
                } else {
                    self.loadingData = false;
                }
            });

        return defer.promise;
    };

    self.handleMismatchHireDateChange = function () {
        if (employee_first_day && self.data.hiringDate) {
            self.data.hiringDate = moment(self.data.hiringDate.format("MMM DD, YYYY"));
            var dateDifferenceAsDays = self.data.hiringDate.diff(employee_first_day, 'days');
            self.isShowWarningMsg = (dateDifferenceAsDays !== 0);
        }
    };

    self.goToUserProfile = function () {
        if (self.isTeamScheduledEnabled) {
            var routeParams = {
                user_id: self.coreHREmployeeDetails.id,
                brand_id: self.coreHREmployeeDetails.financial_unit_brand_id,
                tab: 'personalInfo'
            };

            var coreHrProfileURL = $state.href('appLayout.harriSH.core-hr.profile', routeParams);
            window.open(coreHrProfileURL, '_blank');
        }
    };

	self.onSelectedWorkLocation = function () {
        var defer = $q.defer();
        delete self.data.mapping_error;
        wotcDataService.getLocationMappings(self.brand_id, self.data.assigned_work_location)
            .then(function (response) {
                if (response.location_mappings.length === 0) {
                    self.data.mapping_error = true;
                }
                defer.resolve();
            }).catch(function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.validator.validateCustom = function (field, optionsField, rule) {
        switch (rule.name) {
            case "past-hire-date":
                if (moment(self.data.hiringDate.format("MMMM DD, YYYY")).isSameOrBefore(moment(self.lastTerminationDate).format("MMMM DD, YYYY"))) {
                    return false;
                }

        }
        return true;
    };

	self.save = function () {
		var deferred = $q.defer();

        if (self.validator.validate() && !self.data.mapping_error) {
            var hiringDate = moment(self.data.hiringDate).format('YYYY-MM-DD');
            var actual_start_date = moment(self.data.actual_start_date).format('YYYY-MM-DD');
            var offer_sent_date = moment(self.data.offer_sent_date).format('YYYY-MM-DD');
            var birth_date = moment(self.data.birth_date).format('YYYY-MM-DD');
            var prospect = self.data.position.prospect_id;

            var formData = {
                "id": prospect,
                "start_date": hiringDate,
                "actual_start_date": actual_start_date,
                "offer_sent_date": offer_sent_date,
                "location_id": self.data.assigned_work_location,
                "wage": self.data.wage,
                "paying_frequency": self.data.paying_frequency,
                "position_title": self.data.position_title,
                "birth_date": birth_date,
                "ssn": self.data.ssn
            };

            if (!prospect) {
                prospect = {
                    "user_id": self.employee.user_id,
                    "brand_id": self.brand_id,
                    "position_id": self.data.position.id,
                    "job_id": self.employee.position.job_id,
                    "application_id": self.employee.position.application_id
                };
            }

            self.processing = true;

            formData.candidate_id = self.employee.user_id;
            formData.prospect = prospect;


            deferred.resolve(formData);
        } else {
            deferred.resolve({});
        }

		return deferred.promise;
	};

};
